/**
 * Render the final JSX of MenuTrigger
 *
 * Only renders children
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderToastTrigger_unstable", {
    enumerable: true,
    get: function() {
        return renderToastTrigger_unstable;
    }
});
const renderToastTrigger_unstable = (state)=>state.children;
